const constructUiCommand = (calls) => {
  return JSON.stringify({ CustomV1: { calls } });
};
export {
  constructUiCommand
};
//# sourceMappingURL=constructUiCommand.js.map